import immutabilityHelper from 'immutability-helper'
import QS from 'qs'

const buildQuery = routeStack => {
  let head = routeStack[0] || {}
  let { target, params } = head
  let existingParams = QS.parse(window.location.search.slice(1))

  params = JSON.stringify(params || {})

  return `?${QS.stringify({ ...existingParams, target, params })}`
}

export const createStack = (...vals) => {
  let state = { routeStack: vals }
  let query = QS.parse(window.location.search.substring(1))
  let replace = false
  const isPWA =
    window.navigator.standalone ||
    window.matchMedia('(display-mode: standalone)').matches

  // addresses routing issue with PWAs
  if (isPWA) window.history.replaceState({ routeStack: vals }, null)

  if (window.history.state && window.history.state.routeStack) {
    vals = window.history.state.routeStack
  } else if (query.target) {
    let params = {}

    try {
      params = JSON.parse(query.params || '{}')
    } catch (err) {
      console.log('ERROR PARSING PARAMS:', query.params)
    }

    let { target } = query

    vals = [{ target, params }, ...vals]
    state = { routeStack: vals }
    replace = true
  } else {
    replace = true
  }

  if (replace) {
    let query = buildQuery(vals)
    window.history.replaceState(state, null, query)
  }

  return vals
}

export const push = (stack, newValue, navigate = true) => {
  let routeStack = immutabilityHelper(stack, {
    $splice: [[0, 0, newValue]],
  })

  let query = buildQuery(routeStack)

  if (navigate) {
    window.history.pushState({ routeStack }, null, query)
  } else {
    window.history.replaceState({ routeStack }, null, query)
  }

  return routeStack
}

export const peek = (stack, offset = 0) => {
  return stack[offset]
}

export const pop = (stack, replace = false) => {
  let head = stack[0]

  let newStack = immutabilityHelper(stack, {
    $splice: [[0, 1]],
  })

  let state = (window.history.state && window.history.state.routeStack) || []
  let stateHead = state[0] || {}
  let newHead = peek(newStack) || {}

  if (stateHead.target !== newHead.target) {
    window.history.pushState({ routeStack: newStack }, null)
  }

  return [head, newStack]
}
